export enum BookmarkType {
  RegularBookmark = 1,
  ToolBookmark = 2,
  AllBookmarks = 3,
}

export enum BookmarkSortingType {
  RecentlyAdded = 1,
  Title = 2,
  Newest = 3,
  Oldest = 4,
}

export enum PhoneNumberType {
  Work = 1,
  Home = 2,
  School = 3,
  Mobile = 4,
}

export enum LocationType {
  Global = 'SHRM Global',
  India = 'SHRM India',
  Mena = 'SHRM MENA',
}

export enum UserStatus {
  Anonymous = 0,
  Customer = 1,
  Member = 2,
  ExpiringMember = 3,
  ExpiredMember = 4,
  GracePeriodMember = 5,
}
